import React from 'react';
import { ImageWithSkeleton } from '../../../skeleton';
import './SettingsCard.css';

// Константа для базового URL
const NODE_HOST = process.env.REACT_APP_NODE_HOST || 'http://localhost:8080';

const SettingsCard = ({ 
  settings, 
  onEdit, 
  onDelete, 
  onActivate, 
  isActive = false,
  isLoading = false,
  className = '' 
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Неизвестно';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getLogoUrl = (logoUrl) => {
    if (!logoUrl) return null;
    if (logoUrl.startsWith('/files/')) {
      return `${NODE_HOST}${logoUrl}`;
    }
    return logoUrl;
  };

  return (
    <div className={`settings-card ${isActive ? 'active' : ''} ${className}`}>
      <div className="settings-card-header">
        <div className="settings-card-title">
          <h4 className="settings-card-name">
            Настройки #{settings.id}
          </h4>
          <div className="settings-card-status">
            {isActive && (
              <span className="settings-card-badge active">
                <span className="settings-card-badge-icon">✓</span>
                Активны
              </span>
            )}
          </div>
        </div>
        <div className="settings-card-meta">
          <span className="settings-card-author">
            Созданы: {settings.name} {settings.surname}
          </span>
          <span className="settings-card-date">
            {formatDate(settings.created_at)}
          </span>
        </div>
      </div>

      <div className="settings-card-preview">
        <div className="settings-card-colors">
          <h5 className="settings-card-colors-title">Цветовая схема</h5>
          <div className="settings-card-color-grid">
            <div 
              className="settings-card-color-item primary"
              style={{ backgroundColor: settings.primary_color }}
            >
              <span className="settings-card-color-label">Основной</span>
              <span className="settings-card-color-value">{settings.primary_color}</span>
            </div>
            <div 
              className="settings-card-color-item secondary"
              style={{ backgroundColor: settings.secondary_color }}
            >
              <span className="settings-card-color-label">Дополнительный</span>
              <span className="settings-card-color-value">{settings.secondary_color}</span>
            </div>
            <div 
              className="settings-card-color-item text"
              style={{ 
                backgroundColor: settings.text_color,
                color: settings.active_color
              }}
            >
              <span className="settings-card-color-label">Текст</span>
              <span className="settings-card-color-value">{settings.text_color}</span>
            </div>
            <div 
              className="settings-card-color-item background"
              style={{ backgroundColor: settings.background_color }}
            >
              <span className="settings-card-color-label">Фон</span>
              <span className="settings-card-color-value">{settings.background_color}</span>
            </div>
          </div>
        </div>

        {settings.logo_url && (
          <div className="settings-card-logo">
            <h5 className="settings-card-logo-title">Логотип</h5>
            <div className="settings-card-logo-preview">
              <ImageWithSkeleton
                src={getLogoUrl(settings.logo_url)}
                alt="Логотип"
                className="settings-card-logo-img"
                skeletonWidth="120px"
                skeletonHeight="60px"
                skeletonShape="rounded"
                          fallbackSrc={require('assets/icon/logo.png')}
              />
            </div>
          </div>
        )}
      </div>

      <div className="settings-card-actions">
        <button
          className="settings-card-action-btn edit"
          onClick={() => onEdit(settings)}
          disabled={isLoading}
          title="Редактировать настройки"
        >
          <span className="settings-card-action-icon">✏️</span>
          <span className="settings-card-action-text">Редактировать</span>
        </button>

        {!isActive && (
          <button
            className="settings-card-action-btn activate"
            onClick={() => onActivate(settings.id)}
            disabled={isLoading}
            title="Активировать настройки"
          >
            <span className="settings-card-action-icon">⚡</span>
            <span className="settings-card-action-text">Активировать</span>
          </button>
        )}

        <button
          className="settings-card-action-btn delete"
          onClick={() => onDelete(settings.id)}
          disabled={isLoading}
          title="Удалить настройки"
        >
          <span className="settings-card-action-icon">🗑️</span>
          <span className="settings-card-action-text">Удалить</span>
        </button>
      </div>

      {isLoading && (
        <div className="settings-card-loading">
          <div className="settings-card-spinner"></div>
          <span className="settings-card-loading-text">Загрузка...</span>
        </div>
      )}
    </div>
  );
};

export default SettingsCard;
